module.exports = __webpack_public_path__ + "media/images/common/menu_shoes-1333d722be75c2b45b7457ad5598612a.gif";